import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { hideLoading, showLoading } from '../redux store/loader'
import '../stylings/videoGalleryAll.css'

const VideoGalleryAll = () => {
  const { videoGallery } = useSelector((state) => state.videoGallery)
  const [search, setSearch]   = useState('')
  const [active, setActive]   = useState(null)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  const thumbUrl = (url) => {
    const id = url.split('/').pop().split('?')[0]
    return 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg'
  }
  const embedUrl = (url) =>
    url.replace('https://youtu.be/', 'https://www.youtube.com/embed/')
       .replace('https://youtu.be', 'https://www.youtube.com/embed')

  const filtered = videoGallery
    ? videoGallery.filter((v) =>
        (v.title || v.eventname || '').toLowerCase().includes(search.toLowerCase())
      )
    : []

  return (
    <Layout>
      <div className="vga-page">

        {/* ── Hero ── */}
        <div className="vga-hero">
          <div className="vga-hero-dots" />
          <div className="vga-hero-blob vga-hero-blob--1" />
          <div className="vga-hero-blob vga-hero-blob--2" />
          <div className="container vga-hero-inner">
            <div className="vga-hero-tag">
              <i className="fa-brands fa-youtube"></i> Video Gallery
            </div>
            <h1 className="vga-hero-title">All Videos</h1>
            <p className="vga-hero-sub">
              Watch school events, performances, activities and highlights — all in one place.
            </p>

            {/* Search */}
            <div className="vga-search-wrap">
              <i className="fa-solid fa-magnifying-glass vga-search-icon"></i>
              <input
                type="text"
                className="vga-search-input"
                placeholder="Search videos by title…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button className="vga-search-clear" onClick={() => setSearch('')}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="container vga-body">

          {/* Summary */}
          {videoGallery && videoGallery.length > 0 && (
            <div className="vga-summary">
              <span className="vga-summary-count">
                <i className="fa-brands fa-youtube"></i>
                {filtered.length} {filtered.length === 1 ? 'video' : 'videos'}
                {search && ` for "${search}"`}
              </span>
              <span className="vga-summary-label">Click to play</span>
            </div>
          )}

          {/* Grid */}
          {!videoGallery || videoGallery.length === 0 ? (
            <div className="vga-empty">
              <div className="vga-empty-icon"><i className="fa-brands fa-youtube"></i></div>
              <h3>No Videos Yet</h3>
              <p>Video uploads will appear here once published.</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="vga-empty">
              <div className="vga-empty-icon"><i className="fa-solid fa-magnifying-glass"></i></div>
              <h3>No Results Found</h3>
              <p>No videos match "<strong>{search}</strong>". Try a different keyword.</p>
            </div>
          ) : (
            <div className="vga-grid">
              {filtered.map((item) =>
                item.attachments.map((att, ai) => ai < 1 && (
                  <div className="vga-card" key={item.id}>

                    {/* Video / Thumbnail */}
                    {active === item.id ? (
                      <div className="vga-iframe-wrap">
                        <iframe
                          src={embedUrl(att.path) + '?autoplay=1&rel=0'}
                          title={item.title || item.eventname || 'School Video'}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </div>
                    ) : (
                      <div
                        className="vga-thumb"
                        onClick={() => setActive(item.id)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && setActive(item.id)}
                        aria-label={'Play ' + (item.title || item.eventname || 'video')}
                      >
                        <img
                          src={thumbUrl(att.path)}
                          alt={item.title || 'School Video'}
                          className="vga-thumb-img"
                          onError={(e) => { e.target.style.display = 'none' }}
                        />
                        <div className="vga-thumb-overlay" />
                        <div className="vga-play-ring">
                          <div className="vga-play-btn">
                            <i className="fa-solid fa-play"></i>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Footer */}
                    <div className="vga-card-foot">
                      <div className="vga-card-info">
                        <h3 className="vga-card-title">
                          {item.title || item.eventname || 'School Event'}
                        </h3>
                        <span className="vga-card-date">
                          <i className="fa-solid fa-calendar-days"></i>
                          {moment(item.eventdate).format('DD MMM YYYY')}
                        </span>
                      </div>
                      <Link to={`/video/${item.id}`} className="vga-card-btn">
                        <i className="fa-solid fa-film"></i>
                      </Link>
                    </div>

                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default VideoGalleryAll
